// Namespace registry. Each namespace has an English source file (en/<ns>.ts) and a Chilean Spanish file
// (es-CL/<ns>.ts) that must define exactly the same keys, which the type checker enforces. English ships in the
// main bundle; other languages are registered in their own folder's index.ts and loaded on demand by ../index.tsx.
import common from './en/common'
import marketing from './en/marketing'
import auth from './en/auth'
import legal from './en/legal'
import publicPages from './en/publicPages'
import shell from './en/shell'
import ui from './en/ui'
import assets from './en/assets'
import beacons from './en/beacons'
import employee from './en/employee'
import leave from './en/leave'
import lib from './en/lib'
import map from './en/map'
import pay from './en/pay'
import performance from './en/performance'
import profile from './en/profile'
import dashboard from './en/dashboard'
import reports from './en/reports'
import timesheets from './en/timesheets'
import siteDetail from './en/siteDetail'
import employeeDetail from './en/employeeDetail'
import roster from './en/roster'
import jobs from './en/jobs'
import jobCosts from './en/jobCosts'
import locationRequest from './en/locationRequest'
import locationShare from './en/locationShare'
import shifts from './en/shifts'
import swaps from './en/swaps'
import chat from './en/chat'
import orgChart from './en/orgChart'
import employeesAdmin from './en/employeesAdmin'
import sitesAdmin from './en/sitesAdmin'
import geometry from './en/geometry'
import settings from './en/settings'
import billing from './en/billing'
import checklists from './en/checklists'
import adminMisc from './en/adminMisc'
import superAdmin from './en/superAdmin'
import reseller from './en/reseller'
import reminders from './en/reminders'
import emergency from './en/emergency'
import agencies from './en/agencies'
import onboarding from './en/onboarding'
import devices from './en/devices'

export const en = {
  common,
  marketing,
  auth,
  legal,
  publicPages,
  shell,
  ui,
  assets,
  beacons,
  employee,
  leave,
  lib,
  map,
  pay,
  performance,
  profile,
  dashboard,
  reports,
  timesheets,
  siteDetail,
  employeeDetail,
  roster,
  jobs,
  jobCosts,
  locationRequest,
  locationShare,
  shifts,
  swaps,
  chat,
  orgChart,
  employeesAdmin,
  sitesAdmin,
  geometry,
  settings,
  billing,
  checklists,
  adminMisc,
  superAdmin,
  reseller,
  reminders,
  emergency,
  agencies,
  onboarding,
  devices,
}

export type Messages = typeof en
export type Translation = { [N in keyof Messages]: Record<keyof Messages[N], string> }
